import axios from "axios";
export default {
    getGraphNodeImageContent: (largeAttributeId) => axios.get("/Documents/GetGraphNodeImageContent", {
        params: { largeAttributeId }
    }),
    getDocumentTaskResultLimit: (documentId) => axios.post("/Documents/GetDocumentTaskResultLimit", { documentId }),
    saveDocumentTaskResultLimit: (documentId, taskResultLimit) => axios.post("/Documents/SaveDocumentTaskResultLimit", { documentId, taskResultLimit })
};
